// extracted by mini-css-extract-plugin
module.exports = {"link":"link___1Pfy_"};